module.exports = __webpack_public_path__ + "img/go-vented-pipe-min.6f96f3e4.jpg";